import api from '@pray/shared/utils/api';

export async function updateLocalizedContent({
  artistId = '',
  contentId = '',
  locale = '',
  primaryImageUrl = undefined,
  title = undefined,
  description = undefined,
  isPublished = undefined,
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale code is required');

  const data = {};

  if (primaryImageUrl !== undefined) data.primary_image_url = primaryImageUrl;
  if (title !== undefined) data.title = title;
  if (description !== undefined) data.description = description;
  if (isPublished !== undefined) data.is_published = isPublished;

  if (Object.keys(data).length === 0) return null;

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}`;
  const response = await api.executePutRequest(url, data);

  return response.data.data;
}
